/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IUploadImageRequest, TUploadImageModel, IMappers, TUploadImageResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUploadImageResponse } from '../../entities/images/UploadImageResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUploadImageModel(parameters: IUploadImageRequest): TUploadImageModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'promotions-flow-control',
    pathApi: '/v1/upload-image/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'formData',
      parameters,
    },
  };
}

export interface IUploadImageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IUploadImageRequest;
}

export async function fetchUploadImage<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUploadImageOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUploadImageResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUploadImageModel(parameters),
    config,
  )) as FetchResponse<TUploadImageResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUploadImageResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUploadImageResponse>;
}
